<template>
  <main>
    <ContentArchive />
  </main>
</template>

<script>
const ContentArchive = () => import('@/components/Archive/Content')

export default {
  components: {
    ContentArchive
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
</style>
